import React, { Component } from 'react';
import './SitePlan3D.css';
import ModelRefs from '../modelling/ModelRefs';
import SitePlan3DViewModel from '../view_models/SitePlan3DViewModel';
import SitePlan3DView from '../views/3d/SitePlan3DView';
import Slider from './Slider';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import BabylonModelsManager from '../modelling/BabylonModelsManager';
import Models from '../modelling/Models';
import BabylonScene from '../modelling/BabylonScene';
import GroupedCallbacks from '../core/GroupedCallbacks';
import Urls from '../urls/Urls';
import Dialog from './Dialog';
import ParameterErrors from '../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;

export default class SitePlan3D extends Component {
	
    constructor(props) {
        super(props);
		const {hide, getInsertedMenuItemsHandler, getInsertedMenuItemsAtEndHandler, getConfiguration}=props;
		this._getConfiguration= getConfiguration;
		this.hide = hide;
		this._getInsertedMenuItemsHandler = getInsertedMenuItemsHandler;
        this.load = this.load.bind(this);
        this.setVisible = this.setVisible.bind(this);
        this._load = this._load.bind(this);
        this._displayErrorDialog = this._displayErrorDialog.bind(this);
        this._retryLoad = this._retryLoad.bind(this);
        this._retryLoadWithLowerResolution = this._retryLoadWithLowerResolution.bind(this);
        this._elementRef = React.createRef();
        this.state = {visible:false};
		this._groupedCallbacksLoad = null;
		this._currentDialog = null;
		this._insertedMenuItemsRemoveHandle = null;
    }
	load(siteJson){
		this._siteJson = siteJson;
		return new Promise((resolve, reject)=>{
			if(!this._groupedCallbacksLoad){
				this._groupedCallbacksLoad = new GroupedCallbacks();
				setTimeout(this._load,0);
			}
			this._groupedCallbacksLoad.then(resolve);
			this._groupedCallbacksLoad.catch(reject);
		});
	}
	_load(){
		const sitePlan3DViewModel = new SitePlan3DViewModel({siteJson:this._siteJson, configuration:this._getConfiguration()});
		let rootView;
		const babylonScene = new BabylonScene({onReadyToAddSceneComponents:()=>{
			rootView.initialize()
			.then(this._groupedCallbacksLoad.doThen)
			.catch((err)=>{
				console.error(err);
				this._groupedCallbacksLoad.doCatch(err);
				this._groupedCallbacksLoad= null;
				this._displayErrorDialog();
			});
		}});
		const babylonModelsManager = new BabylonModelsManager({modelRefs:this._modelRefs, models:this._siteJson.models,
			babylonScene, modelsRootUrl:Urls.getAssetsForSite(this._getConfiguration().siteSlug) });
		rootView = new SitePlan3DView({model:sitePlan3DViewModel, element:this._elementRef.current, babylonScene:babylonScene, babylonModelsManager:babylonModelsManager});
	}
	_displayErrorDialog({retry, retryWithLowerResolution}){
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'Failed to load :(',
			options:[
				{text:'Retry', callback:this._retryLoad}, 
				{text:'Retry with lower resolution', callback:this._retryLoadWithLowerResolution},
				{text:'Cancel', callback:this.hide}
			]}
		);
	}
	_retryLoad(){
		this._load();
	}
	_retryLoadWithLowerResolution(){
		this._load();
	}
	setVisible(value){
		this._insertedMenuItemsRemoveHandle?.dispose();
		this._insertedMenuItemsRemoveHandle = null;
		if(value){
			this._insertedMenuItemsRemoveHandle = this._getInsertedMenuItemsHandler().registerMenuItems([
					(<IconButton className="site-plan-360-back-button" 
					imgUrl ={Urls.assets+'icons/UI_Button_Exit.png'} onClick={this.hide} key={HashSource.next()}></IconButton>)
				]
			);
		}
		this.setState({visible:value});
	}
    render() {
		const className = 'site-plan-3d '+(this.state.visible?'visible':'');
        return (
            <div className={className} ref={this._elementRef}>
            </div>
        );
    }
}
